import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post('https://bank2.daolog.net/forgot-password', { email });
      setMessage(response.data.message);
      setError('');
    } catch (err) {
      setError(err.response?.data?.message || 'Сталася помилка');
      setMessage('');
    }
  };

  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: "120px" }}>
      <div className="container-about">
        <h1>Відновлення паролю</h1>
        <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Введіть email"
            required
            className="input-stl"
            style={{ backgroundColor: "#e6f2ff", width: "100%", padding: "10px", margin: "10px 0", borderRadius: "5px", border: "1px solid #ccc", textAlign: "center" }}
          />
          <button type="submit" className="download-button" style={{marginTop: "10px"}} >Відправити</button>
        </form>
        {message && <p style={{ color: "green" }}>{message}</p>}
        {error && <p style={{ color: "red" }}>{error}</p>}
      </div>
    </div>
  );
}

export default ForgotPassword;